var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPositionIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33203 13V3.66667C5.33203 3.04669 5.33203 2.7367 5.40018 2.48236C5.58511 1.79218 6.12421 1.25308 6.81439 1.06815C7.06873 1 7.37872 1 7.9987 1C8.61868 1 8.92867 1 9.183 1.06815C9.87319 1.25308 10.4123 1.79218 10.5972 2.48236C10.6654 2.7367 10.6654 3.04669 10.6654 3.66667V13M3.46536 13H12.532C13.2788 13 13.6521 13 13.9374 12.8547C14.1882 12.7268 14.3922 12.5229 14.52 12.272C14.6654 11.9868 14.6654 11.6134 14.6654 10.8667V5.8C14.6654 5.05326 14.6654 4.6799 14.52 4.39468C14.3922 4.1438 14.1882 3.93982 13.9374 3.81199C13.6521 3.66667 13.2788 3.66667 12.532 3.66667H3.46536C2.71863 3.66667 2.34526 3.66667 2.06004 3.81199C1.80916 3.93982 1.60519 4.1438 1.47736 4.39468C1.33203 4.6799 1.33203 5.05326 1.33203 5.8V10.8667C1.33203 11.6134 1.33203 11.9868 1.47736 12.272C1.60519 12.5229 1.80916 12.7268 2.06004 12.8547C2.34526 13 2.71863 13 3.46536 13Z",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPositionIcon);
export default __webpack_public_path__ + "static/media/PositionIcon.5bf3df3f431702dc2b0ca2d4b3e159fc.svg";
export { ForwardRef as ReactComponent };